import { faCalendarClock, faCars } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Grid } from '@mui/material';

export const LineMenuPage = (): React.ReactElement => {
    return (
        <Grid container style={{ width: '100vw', height: '100vh' }} bgcolor={'pink'}>
            <Grid container style={{ width: 2500, height: 841 }} bgcolor={'black'}>
                <Grid
                    container
                    item
                    flexDirection={'column'}
                    style={{ flex: 1, justifyContent: 'center', alignItems: 'center', height: '100%', borderRight: '4px dashed white' }}
                >
                    <Grid container item justifyContent={'center'} alignItems={'center'} sx={{ height: '76%' }}>
                        <FontAwesomeIcon
                            icon={faCalendarClock}
                            fixedWidth
                            style={{
                                color: 'white',
                                width: 'auto',
                                height: '98%',
                            }}
                        />
                    </Grid>
                    <Grid
                        container
                        item
                        justifyContent={'center'}
                        alignItems={'center'}
                        flex={1}
                        sx={{
                            fontSize: 150,
                            fontWeight: 'bold',
                            fontFamily: '"Microsoft JhengHei", verdana, sans-serif',
                            color: 'white',
                            // WebkitTextStroke: '4px black',
                        }}
                    >
                        {'我要候位'}
                    </Grid>
                </Grid>
                <Grid
                    container
                    item
                    flexDirection={'column'}
                    style={{ flex: 1, justifyContent: 'center', alignItems: 'center', height: '100%' }}
                >
                    <Grid container item justifyContent={'center'} alignItems={'center'} sx={{ height: '76%' }}>
                        <FontAwesomeIcon
                            icon={faCars}
                            fixedWidth
                            style={{
                                color: 'white',
                                width: 'auto',
                                height: '98%',
                            }}
                        />
                    </Grid>
                    <Grid
                        container
                        item
                        justifyContent={'center'}
                        alignItems={'center'}
                        flex={1}
                        sx={{
                            fontSize: 150,
                            fontWeight: 'bold',
                            fontFamily: '"Microsoft JhengHei", verdana, sans-serif',
                            color: 'white',
                            // WebkitTextStroke: '4px black',
                        }}
                    >
                        {'排序看板'}
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};
